// @ts-nocheck
document.addEventListener("DOMContentLoaded", () => {
  const selectedItems = {}; // { variantId: quantity }
  let currentCount = 0;

  const decreaseBtns = document.querySelectorAll(".btn-decrease");
  const increaseBtns = document.querySelectorAll(".btn-increase");
  // カートエリアのボタン・ステータス参照
  const addBtn = document.querySelector(".vc-btn-add");
  const staticBtn = document.querySelector(".vc-btn-static");
  const statusText = document.querySelector(".vc-status .status-text");
  let currentRankLevel = 0;

  // 必須商品の初期化
  const mandatoryCards = document.querySelectorAll(
    '.gift-item-card[data-is-mandatory="true"]',
  );
  mandatoryCards.forEach((card) => {
    const variantId = card.getAttribute("data-variant-id");
    selectedItems[variantId] = 1;
    currentCount++;
  });

  updateStatus(false);
  updateStatusPrice();

  // バリアント選択ボタン
  document.querySelectorAll(".vc-vbtn-item").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const card = e.currentTarget.closest(".gift-item-card");
      const oldVariantId = card.getAttribute("data-variant-id");
      const newVariantId = e.currentTarget.getAttribute("data-variant-id");
      const newPrice = parseInt(e.currentTarget.getAttribute("data-price"), 10);

      if (oldVariantId === newVariantId) return;

      // カードのvariantIdを新しいバリアントに更新
      card.setAttribute("data-variant-id", newVariantId);

      // selectedItemsの数量を引き継ぎ
      const currentQty = selectedItems[oldVariantId] || 0;
      if (currentQty > 0) {
        delete selectedItems[oldVariantId];
        selectedItems[newVariantId] = currentQty;
      }

      // ボタンのアクティブ状態を更新
      card
        .querySelectorAll(".vc-vbtn-item")
        .forEach((b) => b.classList.remove("is-active"));
      e.currentTarget.classList.add("is-active");

      // 価格表示を更新
      const priceEl = card.querySelector(".gift-item-price");
      if (priceEl) {
        priceEl.textContent =
          "¥" + Math.round(newPrice / 100).toLocaleString("ja-JP");
      }

      updateStatus(false);
      updateStatusPrice();
    });
  });

  // アイテム減少
  decreaseBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const card = e.target.closest(".gift-item-card");
      const variantId = card.getAttribute("data-variant-id");
      const countEl = card.querySelector(".item-count");
      const isMandatory = card.getAttribute("data-is-mandatory") === "true";
      const minCount = isMandatory ? 1 : 0;

      if (selectedItems[variantId] && selectedItems[variantId] > minCount) {
        selectedItems[variantId]--;
        currentCount--;
        countEl.textContent = selectedItems[variantId];
        updateStatus(true);
        updateStatusPrice();
      }
    });
  });

  // アイテム増加
  increaseBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const card = e.target.closest(".gift-item-card");
      const variantId = card.getAttribute("data-variant-id");
      const countEl = card.querySelector(".item-count");

      selectedItems[variantId] = (selectedItems[variantId] || 0) + 1;
      currentCount++;
      countEl.textContent = selectedItems[variantId];
      updateStatus(true);
      updateStatusPrice();
    });
  });

  // 合計金額計算（selectedItems と priceMap から 1/100円単位で返す）
  function calculateTotal() {
    const priceMap = (window.VolumeSelectionConfig || {}).priceMap || {};
    let total = 0;
    for (const [variantId, quantity] of Object.entries(selectedItems)) {
      if (quantity > 0 && priceMap[variantId]) {
        total += priceMap[variantId] * quantity;
      }
    }
    return total;
  }

  // 金額フォーマット（1/100円単位 → ¥1,234）
  function formatMoney(cents) {
    return "¥" + Math.round(cents / 100).toLocaleString("ja-JP");
  }

  function updateStatus(isUserAction) {
    const cfg = window.VolumeSelectionConfig || {};
    const itemUnit = cfg.itemUnit || "缶";
    const bronze = parseInt(cfg.bronzeQty, 10) || 4;
    const silver = parseInt(cfg.silverQty, 10) || 7;
    const gold = parseInt(cfg.goldQty, 10) || 10;

    let newRankLevel = 0;
    if (currentCount >= gold) newRankLevel = 3;
    else if (currentCount >= silver) newRankLevel = 2;
    else if (currentCount >= bronze) newRankLevel = 1;
    currentRankLevel = newRankLevel;

    // statusTextはdiscount_bannerブロックがある時のみ存在する
    if (statusText) {
      const msg0 = cfg.msgRank0 || "";
      const msg1 = cfg.msgBronze || "";
      const msg2 = cfg.msgSilver || "";
      const msg3 = cfg.msgGold || "";
      const formatDiff = (n) =>
        `<span class="highlight" style="font-size:1.2em;">${n}</span>`;

      const replacePlaceholders = (msg, diffVal = 0) => {
        return msg
          .replace(/\n/g, "<br>")
          .replace(/\[数量\]/g, currentCount)
          .replace(/\[X\]/g, currentCount)
          .replace(/\[残り数量\]/g, formatDiff(diffVal))
          .replace(/\[DIFF\]/g, formatDiff(diffVal))
          .replace(/\[単位\]/g, itemUnit);
      };

      if (currentCount < bronze) {
        statusText.innerHTML = replacePlaceholders(msg0, bronze - currentCount);
      } else if (currentCount < silver) {
        statusText.innerHTML = replacePlaceholders(msg1, silver - currentCount);
      } else if (currentCount < gold) {
        statusText.innerHTML = replacePlaceholders(msg2, gold - currentCount);
      } else {
        statusText.innerHTML = replacePlaceholders(msg3, 0);
      }
    }

    if (addBtn) {
      addBtn.disabled = currentCount < 1;
      const btnText = cfg.cartBtnText || "カートに追加する";
      if (cfg.cartBtnSub !== false) {
        const total = calculateTotal();
        const totalStr = total > 0 ? ` ${formatMoney(total)}` : "";
        addBtn.innerHTML = `${btnText}<br><span class="vc-btn-sub">（合計${currentCount}${itemUnit}${totalStr}）</span>`;
      } else {
        addBtn.textContent = btnText;
      }
    }
    // シンプルカートボタン（静的）
    if (staticBtn) {
      staticBtn.disabled = currentCount < 1;
      const sText = cfg.staticBtnText || "カートに追加する";
      if (cfg.staticBtnSub !== false) {
        const total = calculateTotal();
        const totalStr = total > 0 ? ` ${formatMoney(total)}` : "";
        staticBtn.innerHTML = `${sText}<br><span class="vc-btn-sub">（合計${currentCount}${itemUnit}${totalStr}）</span>`;
      } else {
        staticBtn.textContent = sText;
      }
    }
  }

  // 適用される割引額（1/100円単位）を返す
  function calculateDiscountCents(totalCents, rank) {
    if (rank === 0) return 0;
    const cfg = window.VolumeSelectionConfig || {};
    const type = cfg.priceDiscountType || "percent";
    const yens = [
      0,
      cfg.priceBronzeDiscountYen || 0,
      cfg.priceSilverDiscountYen || 0,
      cfg.priceGoldDiscountYen || 0,
    ];
    const pcts = [
      0,
      cfg.priceBronzeDiscountPct || 0,
      cfg.priceSilverDiscountPct || 0,
      cfg.priceGoldDiscountPct || 0,
    ];
    if (type === "amount") return yens[rank] * 100;
    return Math.round((totalCents * pcts[rank]) / 100);
  }

  // 割引のラベル文字列（例: "5%オフ" or "¥300"）を返す
  function formatDiscountLabel(totalCents, rank) {
    if (rank === 0) return "";
    const cfg = window.VolumeSelectionConfig || {};
    const type = cfg.priceDiscountType || "percent";
    const pcts = [
      0,
      cfg.priceBronzeDiscountPct || 0,
      cfg.priceSilverDiscountPct || 0,
      cfg.priceGoldDiscountPct || 0,
    ];
    if (type === "percent") return `${pcts[rank]}%`;
    return formatMoney(calculateDiscountCents(totalCents, rank));
  }

  // 金額ベースのカートステータス更新
  function updateStatusPrice() {
    const cfg = window.VolumeSelectionConfig || {};
    const itemUnit = cfg.itemUnit || "個";
    // priceXAmount は円単位 → priceMapは1/100円単位なので100倍して比較
    const bronze = (cfg.priceBronzeAmount || 3000) * 100;
    const silver = (cfg.priceSilverAmount || 5000) * 100;
    const gold = (cfg.priceGoldAmount || 10000) * 100;
    const totalCents = calculateTotal();

    let currentPriceRank = 0;
    if (totalCents >= gold) currentPriceRank = 3;
    else if (totalCents >= silver) currentPriceRank = 2;
    else if (totalCents >= bronze) currentPriceRank = 1;

    const discountCents = calculateDiscountCents(totalCents, currentPriceRank);
    const discountedCents = Math.max(0, totalCents - discountCents);
    const discountLabel = formatDiscountLabel(totalCents, currentPriceRank);
    const hl = (n) =>
      `<span class="highlight" style="font-size:1.2em;">${n}</span>`;

    const statusEl = document.querySelector(
      ".vc-status-price .status-text-price",
    );
    if (statusEl) {
      const msgs = [
        cfg.priceMsgRank0 || "",
        cfg.priceMsgBronze || "",
        cfg.priceMsgSilver || "",
        cfg.priceMsgGold || "",
      ];
      const diffAmounts = [
        bronze - totalCents,
        silver - totalCents,
        gold - totalCents,
        0,
      ];
      const diffCents = diffAmounts[currentPriceRank];
      const diffStr = diffCents > 0 ? formatMoney(diffCents) : "";

      statusEl.innerHTML = msgs[currentPriceRank]
        .replace(/\n/g, "<br>")
        .replace(/\[金額\]/g, formatMoney(totalCents))
        .replace(/\[残り金額\]/g, diffStr)
        .replace(/\[割引額\]/g, discountLabel ? hl(discountLabel) : "")
        .replace(/\[数量\]/g, currentCount)
        .replace(/\[単位\]/g, itemUnit);
    }

    const addBtnPrice = document.querySelector(".vc-btn-add-price");
    if (addBtnPrice) {
      addBtnPrice.disabled = currentCount < 1;
      const btnText = cfg.priceCartBtnText || "カートに追加する";
      if (cfg.priceBtnSub !== false) {
        let totalStr = "";
        if (totalCents > 0) {
          if (discountCents > 0) {
            totalStr = ` <s>${formatMoney(totalCents)}</s><br>→${hl(formatMoney(discountedCents))}（${discountLabel}オフ）`;
          } else {
            totalStr = ` ${formatMoney(totalCents)}`;
          }
        }
        addBtnPrice.innerHTML = `${btnText}<br><span class="vc-btn-sub">合計${currentCount}${itemUnit}${totalStr}</span>`;
      } else {
        addBtnPrice.textContent = btnText;
      }
      addBtnPrice.dataset.currentRank = currentPriceRank;
    }
  }

  // カートへ追加（共通処理）
  async function addToCart(btn) {
    if (currentCount < 1) return;

    btn.disabled = true;
    btn.innerHTML = "追加中...";

    const cfg = window.VolumeSelectionConfig || {};
    const itemsToCart = [];
    for (const [variantId, quantity] of Object.entries(selectedItems)) {
      if (quantity > 0) {
        itemsToCart.push({
          id: variantId,
          quantity: quantity,
          properties: { _badge_text: cfg.badgeText || "まとめ買い対象" },
        });
      }
    }

    try {
      const response = await fetch(cfg.cartAddUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToCart }),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || "カート追加に失敗しました");
      }
      window.location.href = cfg.cartUrl || "/cart";
    } catch (e) {
      console.error(e);
      alert("カートの追加に失敗しました。時間をおいて再試行してください。");
      updateStatus(false); // ボタン状態を復元
    }
  }

  // 金額ベースカート追加
  async function addToCartPrice(btn) {
    if (currentCount < 1) return;

    btn.disabled = true;
    btn.innerHTML = "追加中...";

    const cfg = window.VolumeSelectionConfig || {};
    const itemsToCart = [];
    for (const [variantId, quantity] of Object.entries(selectedItems)) {
      if (quantity > 0) {
        itemsToCart.push({
          id: variantId,
          quantity: quantity,
          properties: { _badge_text: cfg.badgeText || "まとめ買い対象" },
        });
      }
    }

    try {
      const response = await fetch(cfg.cartAddUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToCart }),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || "カート追加に失敗しました");
      }
      window.location.href = cfg.cartUrl || "/cart";
    } catch (e) {
      console.error(e);
      alert("カートの追加に失敗しました。時間をおいて再試行してください。");
      updateStatusPrice();
    }
  }

  // 動的カートボタン
  if (addBtn) {
    addBtn.addEventListener("click", () => addToCart(addBtn));
  }

  // シンプルカートボタン
  if (staticBtn) {
    staticBtn.addEventListener("click", () => addToCart(staticBtn));
  }

  // 金額連動カートボタン
  const addBtnPrice = document.querySelector(".vc-btn-add-price");
  if (addBtnPrice) {
    addBtnPrice.addEventListener("click", () => addToCartPrice(addBtnPrice));
  }

  // --- アンカーリンクのスムーズスクロール補正 ---
  (function () {
    function getTargetPosition(el) {
      return el.getBoundingClientRect().top + window.pageYOffset;
    }

    // ページ内リンクのクリックイベント
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        if (href === "#" || href === "") return;
        const target = document.querySelector(href);
        if (target) {
          // モーダル表示モードの場合はスクロール処理をスキップ
          if (target.classList.contains("is-modal-mode")) {
            return;
          }
          
          e.preventDefault();

          let scrollCount = 0;
          let cancelled = false;
          const CANCEL_EVENTS = ["wheel", "touchstart", "touchmove"];

          const cancel = () => {
            cancelled = true;
            clearInterval(scrollInterval);
            CANCEL_EVENTS.forEach((ev) =>
              window.removeEventListener(ev, cancel),
            );
          };
          CANCEL_EVENTS.forEach((ev) =>
            window.addEventListener(ev, cancel, { passive: true }),
          );

          const scrollInterval = setInterval(() => {
            if (cancelled) return;
            const targetPosition = getTargetPosition(target);
            const currentScroll = window.pageYOffset;

            // 位置がズレている（5px以上）場合のみスクロールを実行
            if (Math.abs(currentScroll - targetPosition) > 5) {
              window.scrollTo({
                top: targetPosition,
                behavior: scrollCount === 0 ? "smooth" : "auto",
              });
            }

            scrollCount++;
            // 約5秒間 (100ms * 50) 監視・補正
            if (scrollCount > 50) {
              clearInterval(scrollInterval);
              CANCEL_EVENTS.forEach((ev) =>
                window.removeEventListener(ev, cancel),
              );
            }
          }, 100);
        }
      });
    });

    // ページ読み込み時にハッシュがある場合の処理
    window.addEventListener("load", () => {
      if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
          setTimeout(() => {
            window.scrollTo({
              top: getTargetPosition(target),
              behavior: "smooth",
            });
          }, 800);
        }
      }
    });
  })();

  // --- モーダル制御 ---
  const sectionWrapper = document.querySelector('.vs-section-wrapper');
  if (sectionWrapper && sectionWrapper.dataset.displayMode === 'modal') {
    const modalId = sectionWrapper.id;
    if (modalId) {
      const openModal = () => {
        sectionWrapper.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        sectionWrapper.classList.remove('is-open');
        document.body.style.overflow = '';
      };

      // 対象のアンカーリンクすべてに対して
      document.querySelectorAll(`a[href="#${modalId}"]`).forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation(); // スムーズスクロールを停止（保険）
          openModal();
        });
      });

      // 閉じるボタン
      const closeBtn = sectionWrapper.querySelector('.modal-close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }

      // 背景クリックで閉じる
      sectionWrapper.addEventListener('click', (e) => {
        if (e.target === sectionWrapper) {
          closeModal();
        }
      });
    }
  }

});
